export default {
    byProject(id) {
        return this.transformer.many(
            this.try(
                this.baseQuery().where('projectId', id).get()
            )
        )
    }
}
